"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _sharedStyles = require("../sharedStyles");
var _utils = require("../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var UpcomingEvents = function UpcomingEvents(_ref) {
  var schedule = _ref.schedule,
    isShowing = _ref.isShowing;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: (0, _sharedStyles.cardStyles)({
      isShowing: isShowing
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: _sharedStyles.cardTextStyles1
  }, (0, _utils.getScheduleAvailability)(schedule)), /*#__PURE__*/_react.default.createElement("div", {
    style: _sharedStyles.cardTextStyles2
  }, (0, _utils.getScheduleTime)(schedule)));
};
var _default = exports.default = UpcomingEvents;